export default __webpack_public_path__ + "static/media/backer-mh.8017a4a1.png";